import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import SearchIcon from "@material-ui/icons/Search";
import { useQuery, gql } from "@apollo/client";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import { Grid } from "@material-ui/core";

export default function SearchMeetingNotes(props) {
  const useStyles = makeStyles(x => ({
    inputRoot: {
      backgroundColor: "#FFF",
      padding: "5px",
      borderRadius: "5px"
    }
  }));

  const classes = useStyles();
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const MEETINGNOTES = () => gql`
    query GetmeetingNotes {
        customers(limit:7,where:{
            FullName_contains: "${inputValue}",
  	    }        ){
            id,
            FullName,
        }
    }
  `;
  const { data, loading, error } = useQuery(MEETINGNOTES());
  React.useEffect(() => {
    let active = true;

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }
    if (!loading && data && data.customers) {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }
        newOptions = [...newOptions, ...data.customers];
        setOptions(newOptions);
      }
    }

    return () => {
      active = false;
    };
  }, [value, inputValue, data, loading]);


  const handleSelect = (id)=>{
    props.setSelectedCustomerId(id)
  }
  return (
    <Autocomplete
      style={{ width: "100%" }}
      getOptionLabel={option => option.FullName}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      classes={{
        root: classes.inputRoot,
        input: classes.input
      }}
      renderInput={params => (
        <TextField
          {...params}
          placeholder="Search Customer"
          // variant="outlined"
          classes={{
            input: classes.input,
            root: classes.inputRoot
          }}
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: <SearchIcon className={classes.searchIcon} />,
            disableUnderline: true,
            endAdornment: true
          }}
        />
      )}
      renderOption={option => {
        return (
          <Grid container onClick={()=>handleSelect(option.id)}>
            <Typography>{option.FullName}</Typography>
          </Grid>
        );
      }}
    />
  );
}
